export default __webpack_public_path__ + "static/media/citymap.0d893112.png";